import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AdminPage from "@/pages/AdminPage";
import AdminCalendarPage from "@/pages/AdminCalendarPage";
import AdminDaySummaryPage from "@/pages/AdminDaySummaryPage";
import AdminInvoicePage from "@/pages/AdminInvoicePage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import LookupPage from "@/pages/LookupPage";
import PublicRedirect from "@/pages/PublicRedirect";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public booking has moved — redirect everyone off this host */}
          <Route path="/" element={<PublicRedirect />} />
          <Route path="/book" element={<PublicRedirect />} />
          <Route path="/lookup" element={<LookupPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/calendar" element={<AdminCalendarPage />} />
          <Route path="/admin/day" element={<AdminDaySummaryPage />} />
          <Route path="/admin/invoice/:id" element={<AdminInvoicePage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          {/* Any other unknown public path also bounces to the new site */}
          <Route path="*" element={<PublicRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
